import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import { Image } from '@utils/cook/types'
import { SportCardImage } from '@components/SportCardReusableComponents'
import SvgIcon from '@components/SvgIcon'

type RefereeImageProps = {
  image: Image<'free'> | null
}

const StyledIcon = styled(SvgIcon)`
  ${({
    theme: {
      spacing: { spacing4 },
    },
  }) => css`
    position: absolute;
    left: -${spacing4};
    bottom: -${spacing4};
  `}
`

const StyledImageContainer = styled.div`
  position: relative;
`

const RefereeImage: FunctionComponent<RefereeImageProps> = ({ image }) =>
  image ? (
    <StyledImageContainer>
      <SportCardImage image={image} />
      <StyledIcon iconName="referee" size={24} />
    </StyledImageContainer>
  ) : null

export default RefereeImage
